import { getUrlParam } from '@/utils';
import { v4 as uuid } from 'uuid';
import { ProjectEnum } from './subscription';
import { isWeb } from '@/utils/vip';

let prefix = process.env.REACT_APP_ENV;

if (process.env.REACT_APP_ENV === 'release') {
  prefix = '';
}

/**
 * 接口公共入参字段client_id
 */
export const CLIENT_ID = getUrlParam('client_id') || '1189857435';
// 1 为(预发布+正式),0 或者不传 为正式模式
export const PREVIEW_MODE = process.env.REACT_APP_ENV === 'release' ? 0 : 1;

export const HOST = `https://${prefix}api.posters.meitu.com`;
// SCHOOL_HOST 内网接口；不支持 https；本地调用此域名需要 vpn 和开启host
export const SCHOOL_HOST = `http://${prefix}internal.posters.m.com`;

export const feedbackUrl = `https://${prefix}api-feedback.meitu.com`;
// dnsPrefetch
export const materialCenterUrl =
  process.env.REACT_APP_ENV === 'pre'
    ? '//test-material-center-pre.meitudata.com'
    : '//xiuxiupro-material-center.meitudata.com';

export const pcMeitudataUrl = '//pc.meitudata.com';

export const titanH5Url = '//titan-h5.meitu.com';

export const HOSTNAME = `${prefix}pc.meitu.com`;

export const xiuxiuPro = `https://${prefix}api-xiuxiupro.designkit.cn`;

export const accountUrl = `https://${prefix}account.meitu.com`;

export const mcpUrl = `https://${prefix}mcp.meitu.com`;

/**
 * 埋点SDK的app_key
 */
export const APP_KEY =
  getUrlParam('app_key') ||
  (process.env.REACT_APP_ENV === 'release' ? '43815DC54A66BEE8' : '4A7C91EB253876E6');

/**
 * 比例
 */
export const baseRoot = 144;

export enum SupportV0Type {
  unsupport = '0',
  support = '1',
}

export const systemTypeStatMap: Record<string, string> = {
  win32: 'Windows',
  win64: 'Windows',
  mac: 'Mac',
  linux: 'Linux',
};

// 图片最大尺寸
export const MAX_IMAGE_SIZE = 8000;
// 图片最大大小
export const MAX_IMAGE_FILE_SIZE = 20 * 1024 * 1024;
// 图片压缩尺寸
export const MAX_IMAGE_COMPRESSED_SIZE = 4000;

// 订阅相关的appid
export const appId = '904';
// 订阅:是否沙盒模式，用于订阅商品跟踪beta和release环境的数据
export const IS_SANDBOX = process.env.REACT_APP_ENV === 'release' ? 0 : 1;

// 业务应用的版本号，用于埋点SDK
export const APP_VERSION = '2.0.0';

// 订阅类型
export enum SubscribeType {
  // 订阅版本 - 单购
  CONSUMABLE = 'consumable',
  // 订阅版本 - 会员
  SUBSCRIPTION = 'subscription',
  //  订阅版本 - 美豆
  MEIDOU = 'meidou',
  //  订阅版本 - 美豆套餐
  MEIDOUPACKAGE = 'meidou_package',
  /**
   * logo无限次
   */
  LOGO_UNLIMITED = 'logo_unlimited',
}

export const orderType: { [key: string]: number } = {
  CONSUMALBE: 4,
  NO_CONSUMABLE: 3,
  NO_RENEW: 1,
  RENEW: 2,
  UNKNOWN: 0,
};

// 订阅场景，默认是购买会员
const subscribe_type = getUrlParam('subscribe_type');
export const subscribeType: any = subscribe_type
  ? subscribe_type === 'subscribe' // 有些业务购买会员透传的值是subscribe有些透传的是subscription，统一做兼容处理
    ? SubscribeType.SUBSCRIPTION
    : subscribe_type
  : SubscribeType.SUBSCRIPTION;

/**
 * 通过oid和groupId来判断是团队版订阅还是个人版订阅
 */
export const isTeamSubscription =
  getUrlParam('oid') &&
  getUrlParam('oid') !== '0' &&
  getUrlParam('groupId') &&
  getUrlParam('groupId') !== '0';

// appid商户枚举
export const getAppIdEnum = () => {
  return {
    // 美图设计室会员商户
    MEITUSHEJISHI:
      isTeamSubscription || !isWeb || isFromPcHome ? '6829803307012000000' : '6829803307019000000', // 团队版商户/PC7500之前版本 用web商户，个人版商户 用APP商户
    // 商拍商户(美豆套餐)
    MEIDOUPACKAGE: '6829803307029000000',
  };
};

/**
 * 当前用户的团队角色
 */
export enum TeamRole {
  // 团队管理员
  OWNER = 'owner',
  // 团队所有者
  ADMIN = 'admin',
}

/**
 * 购买场景，主要用于团队版本：普通购买，加购
 */
export enum PurchaseScene {
  // 普通购买
  NORMAL = 'normal',
  // 加购
  EXTRA = 'extra',
}

export const purchaseScene = getUrlParam('purchase_scene') || PurchaseScene.NORMAL;

// 当前会话的唯一标识，需要透传到收银台；当前会话下的所以埋点都需要携带该参数
export const session_id_collection_cd = uuid();

// 红包触发记录
export const RED_ENVELOPE_RECORD = 'red-envelope-records';

/**
 * 主题色
 */
export enum ThemeEnum {
  /**
   * 暗色
   */
  dark = 'dark',
  /**
   * 亮色
   */
  light = 'light',
}

/**
 * 是否来自PPT场景打开的订阅弹窗
 */
export const isFromLivePPT = getUrlParam('module_id') === 'aippt';

/**
 * 是否来自Logo场景打开的订阅弹窗
 */
export const isFromAiLogo = getUrlParam('module_id') === 'ailogo';

/**
 * 是否来自AI图文场景打开的订阅弹窗
 */
export const isFromAiPostgen = getUrlParam('module_id') === 'ai_postgen_web';

/**
 * 是否来自AI文案场景打开的订阅弹窗
 */
export const isFromAiCopywriting = getUrlParam('module_id') === 'ai_copywriting_web';

/**
 * 是否来自AI海报场景打开的订阅弹窗
 */
export const isFromAiHb = getUrlParam('module_id') === 'aihb';

/**
 * 是否来自pc.meitu.com站点
 */
export const isFromPcHome = getUrlParam('project') === ProjectEnum.PcHome;

/**
 * 是否来自抠图站点
 */
export const isFromCutout = window.parent.location.pathname.includes('/cutout');

/**
 * 支付渠道映射
 */
export const channelsMap: Record<string, string> = {
  weixin: '微信',
  alipay: '支付宝',
};
